import { makeStyles } from "tss-react/mui";
import { Grid, Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import CashSettlementsForApprovalSection from "./subpages/CashSettlementsForApprovalSection";
import ApprovedCashSettlementsSection from "./subpages/ApprovedCashSettlementsSection";
import config from "../../../config";
import UnsettledOrdersSection from "./subpages/UnsettledOrdersSection";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    tabs: {
      marginBottom: theme.spacing(3),
      borderBottom: `1px solid ${theme.palette.divider}`
    },
    tabsSlim: {
      borderBottom: `1px solid ${theme.palette.divider}`
    }
  })
);

export default function CashSettlementsPage() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { tabId } = useParams();
  const { slim } = useDevice();

  const navigate = useNavigate();
  const onTabChange = useCallback((_, val) => navigate(!!tabId ? `../${val}` : `./${val}`, { relative: "path", replace: true }), [navigate, tabId]);

  return (
    <ResponsivePage
      title={t("cashSettlements:title")}
      maxWidth={config.pageSize.large}
    >

      <Grid item xs={12}>
        <Tabs className={slim ? classes.tabsSlim : classes.tabs} value={tabId || "unsettled"} onChange={onTabChange} variant="scrollable" scrollButtons="auto">
          <Tab value="unsettled" label={t("cashSettlements:unsettledOrdersTab")} />
          <Tab value="approval" label={t("cashSettlements:approvalTab")} />
          <Tab value="archive" label={t("cashSettlements:archiveTab")} />
        </Tabs>
      </Grid>

      {!tabId || tabId === "unsettled" ? (
        <UnsettledOrdersSection />
      ) : tabId === "approval" ? (
        <CashSettlementsForApprovalSection />
      ) : tabId === "archive" ? (
        <ApprovedCashSettlementsSection />
      ) : null
      }

    </ResponsivePage>
  );
}

